import AppShell from "../../App.jsx";
import { AppProviders } from "../providers/AppProviders/AppProviders";

function App() {
  return (
    <AppProviders>
      <AppShell />
    </AppProviders>
  );
}

export default App;
